'use strict';

var addOrRemoveFromDataBasedOnChecked = function (value, newData, isChecked) {
    var _a;
    var allSelectedData = (_a = value === null || value === void 0 ? void 0 : value.slice(0).map(function (selectedData) { return selectedData.value; })) !== null && _a !== void 0 ? _a : [];
    if (isChecked) { // add to current selected items and send to parent
        allSelectedData = allSelectedData.concat(newData.value);
    }
    else { // remove unSelected item and send to parent
        allSelectedData = allSelectedData
            .filter(function (removeData) { return removeData !== newData.value; });
    }
    return allSelectedData;
};

var arrayHasValue = function (data, compareObject) {
    var valueArray = data.map(function (selectedData) { return selectedData.value; });
    return valueArray.includes(compareObject.value);
};

exports.addOrRemoveFromDataBasedOnChecked = addOrRemoveFromDataBasedOnChecked;
exports.arrayHasValue = arrayHasValue;
